import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// ----------------------------------------------------------------------
// 1. إعدادات الاتصال بالسيرفر (Axios)
// ----------------------------------------------------------------------
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://desc.ag.edu.iq/api/';

// ----------------------------------------------------------------------
// 2. إنشاء الـ Thunk للقيام بالعملية غير المتزامنة (إرسال طلب PUT)
// ----------------------------------------------------------------------
export const updateAssessmentResult = createAsyncThunk(
    'updateAssessment/submitUpdate',
    async ({ id, resultText }, { rejectWithValue }) => {
        try {
            // جلب التوكن المحفوظ
            const token = localStorage.getItem('userToken');

            // تجهيز البيانات كـ FormData كما هو موضح في الصورة
            const formData = new FormData();
            formData.append('result', resultText);

            // إرسال الـ PUT Request مع معرف التقييم (id)
            const url = `${BASE_URL}assessment-results/${id}`;
            const response = await axios.put(url, formData, {
                headers: {
                    // في حالة axios عند استخدام FormData، من الأفضل تركه يحدد الـ Content-Type التلقائي (multipart/form-data)
                    'Authorization': `Bearer ${token}` 
                }
            });
            
            return { id, data: response.data }; // نرجع الـ id لمعرفة أي عنصر تم تحديثه
        } catch (error) {
            if (error.response) {
                const data = error.response.data;
                if (data.errors) return rejectWithValue(Object.values(data.errors).flat().join(' - '));
                if (data.message) return rejectWithValue(data.message);
                return rejectWithValue(`خطأ من السيرفر: ${error.response.status}`);
            } else if (error.request) {
                return rejectWithValue('تعذر الوصول إلى السيرفر، تحقق من اتصالك بالإنترنت.');
            }
            return rejectWithValue(error.message || 'حدث خطأ غير متوقع.');
        }
    }
);

// ----------------------------------------------------------------------
// 3. إنشاء الـ Slice لإدارة حالة الـ Redux
// ----------------------------------------------------------------------
const updateAssessmentSlice = createSlice({
    name: 'updateAssessment',
    initialState: {
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
        updatedId: null, // تتبع الـ ID الذي يجري تحديثه
    },
    reducers: {
        resetUpdateState: (state) => {
            state.status = 'idle';
            state.error = null;
            state.updatedId = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateAssessmentResult.pending, (state, action) => {
                state.status = 'loading';
                state.error = null;
                // نحفظ الـ ID لمعرفة أي زر نحوله إلى حالة التحميل
                state.updatedId = action.meta.arg.id; 
            })
            .addCase(updateAssessmentResult.fulfilled, (state) => {
                state.status = 'succeeded';
                state.error = null;
                state.updatedId = null;
            })
            .addCase(updateAssessmentResult.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                state.updatedId = null;
            });
    }
});

export const { resetUpdateState } = updateAssessmentSlice.actions;
export default updateAssessmentSlice.reducer;